import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export const RESEND_DEFAULT_API_KEY = 're_XZVewZbf_74p762EJCrWosPmJZAjJJJe4';

export const getResendApiKey = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('satala_resend_api_key') || RESEND_DEFAULT_API_KEY;
  }
  return RESEND_DEFAULT_API_KEY;
};

export const setResendApiKey = (key) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('satala_resend_api_key', key);
  }
};

const fmt = (n) => new Intl.NumberFormat('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n || 0);

export const generateSalarySlipHTML = ({
  employee,
  paymentPeriod,
  companySettings = {},
  financeManager = 'Finance Manager',
  sourceAccount = 'Satala Dermatech Essential'
}) => {
  const companyName = companySettings?.nama_perusahaan || 'PT. Satala Dermatech Essential';
  const companyAddress = companySettings?.alamat_perusahaan || 'Jalan Aster Kavling Paspampres, Kota Batu, Kec. Ciomas, Bogor';
  const firstName = (employee.full_name || 'Rekan Tim').split(' ')[0];

  return `
<!DOCTYPE html>
<html lang="id">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Slip Gaji - ${employee.full_name}</title>
  <style>
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      background-color: #f6f3ed;
      margin: 0;
      padding: 30px 12px;
      color: #302621;
    }
    .wrapper {
      max-width: 600px;
      margin: 0 auto;
      background: #ffffff;
      border-radius: 24px;
      border: 1px solid #e8dec8;
      overflow: hidden;
      box-shadow: 0 12px 36px rgba(70, 50, 35, 0.08);
    }
    .header {
      background: linear-gradient(135deg, #463223 0%, #2b1c12 100%);
      padding: 32px 28px;
      color: #ffffff;
      text-align: center;
    }
    .badge {
      display: inline-block;
      background: rgba(223, 186, 115, 0.22);
      border: 1px solid #dfba73;
      color: #dfba73;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      padding: 5px 14px;
      border-radius: 20px;
      margin-bottom: 12px;
    }
    .header h1 {
      margin: 0;
      font-size: 22px;
      letter-spacing: 0.5px;
      color: #ffffff;
      font-weight: 800;
    }
    .header p {
      margin: 6px 0 0;
      font-size: 13px;
      color: #d8cbbe;
    }
    .content {
      padding: 32px 28px;
    }
    .greeting {
      font-size: 18px;
      font-weight: 700;
      color: #463223;
      margin: 0 0 14px 0;
    }
    .paragraph {
      font-size: 14.5px;
      line-height: 1.75;
      color: #4a3f38;
      margin: 0 0 16px 0;
    }
    .pdf-box {
      background: linear-gradient(135deg, #f0f7ff 0%, #e8f2fe 100%);
      border: 1.5px solid #bcdbfb;
      border-radius: 16px;
      padding: 20px 22px;
      margin: 26px 0;
      box-shadow: 0 4px 12px rgba(30, 66, 115, 0.06);
    }
    .closing {
      font-size: 14.5px;
      line-height: 1.75;
      color: #4a3f38;
      margin-top: 24px;
      padding-top: 20px;
      border-top: 1px dashed #e8dec8;
    }
    .sign {
      margin-top: 18px;
      font-size: 14px;
      color: #463223;
      font-weight: 600;
    }
    .footer {
      background-color: #f7f3ea;
      padding: 22px;
      text-align: center;
      font-size: 11.5px;
      color: #8c7c72;
      border-top: 1px solid #e8dec8;
      line-height: 1.6;
    }
  </style>
</head>
<body>
  <!-- Preheader text preview in Gmail -->
  <div style="display:none;font-size:1px;color:#ffffff;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">
    Halo Kak ${firstName}! Payday is here 🎉 Slip gaji resmi periode ${paymentPeriod} telah siap dan dilampirkan dalam format PDF. Terima kasih atas kerja kerasmu!
  </div>

  <div class="wrapper">
    <!-- Header -->
    <div class="header">
      <div class="badge">✨ Official Payroll Notification</div>
      <h1>${companyName}</h1>
      <p>Pemberitahuan Resmi Penggajian &bull; Periode ${paymentPeriod}</p>
    </div>

    <!-- Main Content -->
    <div class="content">
      <div class="greeting">Halo Kak ${firstName} & Rekan ${employee.full_name}! 👋✨</div>
      
      <p class="paragraph">
        Semoga harimu selalu menyenangkan dan penuh semangat ya! <i>Yeay, payday is officially here!</i> 💸🥳
      </p>

      <p class="paragraph">
        Mewakili manajemen dan keluarga besar <b>${companyName}</b>, Asa mau ngucapin terima kasih yang sebesar-besarnya atas segala dedikasi, kerja keras, loyalitas, dan energi positif yang sudah Kakak berikan sepanjang bulan <b>${paymentPeriod}</b> ini. Setiap kontribusi dan kerja cerdas Kakak bener-bener berharga banget buat kemajuan tim kita bersama! 🚀
      </p>

      <p class="paragraph">
        Bersama email ini, kami menginformasikan bahwa hak pembayaran gaji Kakak untuk periode ini telah selesai diproses dan ditransfer ke rekening pribadi Kakak.
      </p>

      <!-- PDF Callout Attachment Info -->
      <div class="pdf-box">
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <td style="width: 44px; vertical-align: middle; font-size: 30px; line-height: 1;">📄</td>
            <td style="vertical-align: middle; font-size: 13.5px; color: #1e3a8a; line-height: 1.6;">
              <strong style="color: #1e40af; font-size: 14.5px;">Berkas Resmi Slip Gaji (PDF) Telah Dilampirkan</strong><br/>
              Untuk rincian lengkap penerimaan, tunjangan, potongan, serta pengesahan manajemen, silakan langsung unduh berkas PDF yang telah Asa lampirkan di bagian bawah email ini ya.
            </td>
          </tr>
        </table>
      </div>

      <!-- Closing Message from Asa & Team -->
      <div class="closing">
        Selamat menikmati hasil kerja keras bulan ini ya, Kak! Jangan lupa luangkan waktu buat <i>self-care</i>, <i>quality time</i> bareng orang tersayang, dan <i>recharge</i> energi. <i>Let's keep shining and achieve even bigger milestones together next month!</i> 🌟💖
        
        <div class="sign">
          Salam hangat & penuh semangat,<br/>
          <strong>Asa</strong> & <strong>Tim Finance & HR Satala Dermatech Essential</strong> 💼✨
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer">
      <p style="margin: 0; font-weight: bold; color: #463223;">${companyName}</p>
      <p style="margin: 3px 0 8px 0;">${companyAddress}</p>
      <p style="margin: 0; font-size: 10.5px; color: #a89a8a;">
        Email ini dikirim secara otomatis oleh Sistem Payroll Satala. Berkas PDF yang dilampirkan sah secara internal perusahaan.
      </p>
    </div>
  </div>
</body>
</html>
  `;
};

export const generateSalarySlipPDFBase64 = ({
  employee,
  paymentPeriod,
  companySettings = {},
  financeManager = 'Finance Manager',
  sourceAccount = 'Satala Dermatech Essential'
}) => {
  try {
    const doc = new jsPDF({ format: 'a4', unit: 'mm' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const companyName = companySettings?.nama_perusahaan || 'PT. SATALA DERMATECH ESSENTIAL';
    const companyAddress = companySettings?.alamat_perusahaan || 'Jalan Aster Kavling Paspampres, Kota Batu, Kec. Ciomas, Bogor';

    const allowances = [
      ...(employee.fixed_allowances || []),
      ...((employee.extra_components || []).filter(c => c.type === 'allowance'))
    ];
    
    const deductions = [
      ...(employee.fixed_deductions || []),
      ...((employee.extra_components || []).filter(c => c.type === 'deduction'))
    ];

    const totalAllowances = allowances.reduce((sum, a) => sum + Number(a.amount || 0), 0);
    const totalDeductions = deductions.reduce((sum, d) => sum + Number(d.amount || 0), 0);
    const baseSalary = Number(employee.base_salary || 0);
    const thp = baseSalary + totalAllowances - totalDeductions;
    const payDate = new Date().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });

    // Header
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);
    doc.setTextColor(140, 98, 8); // #8C6208
    doc.text(companyName.toUpperCase(), 20, 20);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(120, 120, 120);
    doc.text(companyAddress, 20, 25);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(50, 40, 30);
    doc.text('SLIP GAJI KARYAWAN', pageWidth - 20, 20, { align: 'right' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(140, 98, 8);
    doc.text(`Periode: ${paymentPeriod}`, pageWidth - 20, 26, { align: 'right' });

    // Divider line
    doc.setDrawColor(220, 200, 170);
    doc.setLineWidth(0.5);
    doc.line(20, 30, pageWidth - 20, 30);

    // Info Box Left: Karyawan
    doc.setFillColor(252, 250, 246);
    doc.roundedRect(20, 35, 82, 36, 2, 2, 'F');
    doc.setDrawColor(235, 225, 210);
    doc.roundedRect(20, 35, 82, 36, 2, 2, 'D');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(70, 50, 35);
    doc.text('INFORMASI KARYAWAN', 24, 41);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Nama', 24, 48);
    doc.text('Jabatan', 24, 54);
    doc.text('Email', 24, 60);
    doc.text('Kategori', 24, 66);

    doc.setFont('helvetica', 'bold');
    doc.setTextColor(40, 40, 40);
    doc.text(`: ${employee.full_name || '-'}`, 42, 48);
    doc.text(`: ${employee.role || employee.position || 'Staf'}`, 42, 54);
    doc.text(`: ${employee.email || '-'}`, 42, 60);
    doc.text(`: ${(employee.company_category || 'SDE') === 'ASB' ? 'Apa Saja Bisa (ASB)' : 'Satala Dermatech Essential (SDE)'}`, 42, 66);

    // Info Box Right: Payroll
    doc.setFillColor(252, 250, 246);
    doc.roundedRect(108, 35, 82, 36, 2, 2, 'F');
    doc.setDrawColor(235, 225, 210);
    doc.roundedRect(108, 35, 82, 36, 2, 2, 'D');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(70, 50, 35);
    doc.text('INFORMASI PAYROLL', 112, 41);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Tanggal', 112, 48);
    doc.text('Metode', 112, 54);
    doc.text('Bank', 112, 60);
    doc.text('No. Rekening', 112, 66);

    doc.setFont('helvetica', 'bold');
    doc.setTextColor(40, 40, 40);
    doc.text(`: ${payDate}`, 134, 48);
    doc.text(`: Transfer ${employee.bank_name || 'Bank'}`, 134, 54);
    doc.text(`: ${employee.bank_name || 'BCA'} (${(employee.account_name || employee.full_name || '').toUpperCase()})`, 134, 60);
    doc.text(`: ${employee.bank_account || '-'}`, 134, 66);

    // Table
    const tableBody = [
      ['Gaji Pokok', fmt(baseSalary), '-'],
      ...allowances.map(a => [a.name || 'Penerimaan', fmt(Number(a.amount || 0)), '-']),
      ...deductions.map(d => [d.name || 'Potongan', '-', fmt(Number(d.amount || 0))]),
      ['TOTAL', fmt(baseSalary + totalAllowances), fmt(totalDeductions)]
    ];

    autoTable(doc, {
      startY: 76,
      head: [['DESKRIPSI KOMPONEN', 'PENERIMAAN (IDR)', 'POTONGAN (IDR)']],
      body: tableBody,
      theme: 'plain',
      headStyles: {
        fillColor: [70, 50, 35],
        textColor: [255, 255, 255],
        fontSize: 8,
        fontStyle: 'bold',
        halign: 'left'
      },
      styles: {
        fontSize: 8,
        cellPadding: 3,
        lineColor: [235, 225, 210],
        lineWidth: 0.2
      },
      columnStyles: {
        0: { cellWidth: 90 },
        1: { halign: 'right', cellWidth: 40 },
        2: { halign: 'right', cellWidth: 40 }
      },
      margin: { left: 20, right: 20 }
    });

    const finalY = (doc.lastAutoTable?.finalY || 120) + 8;

    // THP & Summary Box
    doc.setFillColor(253, 248, 230);
    doc.roundedRect(20, finalY, 82, 28, 2, 2, 'F');
    doc.setDrawColor(223, 186, 115);
    doc.roundedRect(20, finalY, 82, 28, 2, 2, 'D');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(140, 98, 8);
    doc.text('TAKE HOME PAY (GAJI BERSIH)', 24, finalY + 8);
    doc.setFontSize(13);
    doc.text(`Rp ${fmt(thp)}`, 24, finalY + 18);

    doc.setFillColor(252, 250, 246);
    doc.roundedRect(108, finalY, 82, 28, 2, 2, 'F');
    doc.setDrawColor(235, 225, 210);
    doc.roundedRect(108, finalY, 82, 28, 2, 2, 'D');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(70, 50, 35);
    doc.text('RINGKASAN PAYROLL', 112, finalY + 8);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Total Penerimaan', 112, finalY + 15);
    doc.text('Total Potongan', 112, finalY + 22);

    doc.setFont('helvetica', 'bold');
    doc.setTextColor(40, 40, 40);
    doc.text(`: Rp ${fmt(baseSalary + totalAllowances)}`, 145, finalY + 15);
    doc.text(`: Rp ${fmt(totalDeductions)}`, 145, finalY + 22);

    // Signatures
    const sigY = finalY + 36;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Penerima,', 40, sigY, { align: 'center' });
    doc.text(`Bogor, ${payDate}\nPengirim,`, pageWidth - 40, sigY, { align: 'center' });

    doc.setFont('helvetica', 'bold');
    doc.setTextColor(40, 40, 40);
    doc.text(employee.full_name || 'Karyawan', 40, sigY + 22, { align: 'center' });
    doc.text(financeManager || 'Anissa Nurul Fadilah', pageWidth - 40, sigY + 22, { align: 'center' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7);
    doc.setTextColor(120, 120, 120);
    doc.text(employee.role || employee.position || 'Staf', 40, sigY + 26, { align: 'center' });
    doc.text('Finance Manager', pageWidth - 40, sigY + 26, { align: 'center' });

    // Footer Disclaimer
    doc.setDrawColor(220, 200, 170);
    doc.line(20, sigY + 32, pageWidth - 20, sigY + 32);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(7);
    doc.setTextColor(150, 150, 150);
    doc.text('* Dokumen ini diterbitkan secara otomatis oleh sistem payroll dan sah tanpa stempel fisik jika diverifikasi secara internal.', pageWidth / 2, sigY + 36, { align: 'center' });

    // Convert to base64 string
    const arrayBuffer = doc.output('arraybuffer');
    let binary = '';
    const bytes = new Uint8Array(arrayBuffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return typeof btoa !== 'undefined' ? btoa(binary) : Buffer.from(binary, 'binary').toString('base64');
  } catch (err) {
    console.warn("Failed generating PDF attachment:", err);
    return null;
  }
};

/**
 * Mengirim Slip Gaji via Resend API (termasuk lampiran PDF otomatis)
 */
export const sendSalarySlipEmail = async ({
  employee,
  paymentPeriod,
  companySettings = {},
  financeManager = 'Finance Manager',
  sourceAccount = 'Satala Dermatech Essential',
  targetEmail = null,
  pdfBase64 = null
}) => {
  const recipient = targetEmail || employee.email;

  if (!recipient || !recipient.includes('@')) {
    return {
      success: false,
      message: `Email untuk ${employee.full_name} tidak ditemukan. Mohon lengkapi email karyawan.`
    };
  }

  const apiKey = getResendApiKey();
  const htmlContent = generateSalarySlipHTML({
    employee,
    paymentPeriod,
    companySettings,
    financeManager,
    sourceAccount
  });

  const emailPayload = {
    from: 'Satala Finance <finance@sataladermatechessential.com>',
    to: [recipient],
    subject: `Slip Gaji Karyawan - ${employee.full_name} (${paymentPeriod})`,
    html: htmlContent
  };

  // Gunakan pdfBase64 yang diberikan atau generate otomatis
  try {
    const finalPdf = pdfBase64 || generateSalarySlipPDFBase64({
      employee,
      paymentPeriod,
      companySettings,
      financeManager,
      sourceAccount
    });

    if (finalPdf) {
      const cleanName = (employee.full_name || 'Karyawan').replace(/[^a-zA-Z0-9_-]/g, '_');
      const cleanPeriod = (paymentPeriod || '').replace(/[^a-zA-Z0-9_-]/g, '_');
      emailPayload.attachments = [
        {
          filename: `Slip_Gaji_${cleanName}_${cleanPeriod}.pdf`,
          content: finalPdf
        }
      ];
    }
  } catch (pdfErr) {
    console.warn("[SalarySlipEmail] PDF generation bypassed:", pdfErr);
  }

  try {
    // Gunakan proxy Vite /api/resend saat lokal atau direct Resend API
    const isDev = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    const endpoint = isDev ? '/api/resend/emails' : 'https://api.resend.com/emails';

    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(emailPayload)
    });

    const result = await res.json();

    if (!res.ok) {
      // Jika Resend membatasi penerima saat belum custom domain terverifikasi
      if (result?.name === 'validation_error' && result?.message?.includes('own email address')) {
        return {
          success: false,
          isDomainRestriction: true,
          message: `Domain belum terverifikasi di Resend. Silakan verifikasi domain di resend.com/domains.`
        };
      }
      return {
        success: false,
        message: result?.message || `Gagal mengirim email slip gaji (${res.status})`
      };
    }

    return {
      success: true,
      message: `Slip gaji beserta lampiran PDF berhasil dikirim ke ${recipient}`,
      data: result
    };
  } catch (error) {
    console.error('[SalarySlipEmail] Error:', error);
    return {
      success: false,
      message: `Terjadi kendala jaringan saat mengirim email: ${error.message}`
    };
  }
};
